import { connect } from 'react-redux'

import { storeRedirectUrl, storeUsedSocialLogin } from '../../../store/reducers/user'
import { Buttons } from './FederatedButtons'

const MapDispatchToProps = dispatch => ({
  savePage: pageUrl => dispatch(storeRedirectUrl(pageUrl)),
  toggleSocialLogin: () => dispatch(storeUsedSocialLogin(true)),
})

export const FederatedButtons = connect(undefined, MapDispatchToProps)(Buttons)
